import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Plantilla } from './plantillas.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class PlantillaService {

  private plantillasURL: string = urlJoin(environment.apiURL, 'plantillas')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getPlantillas(): Observable<Plantilla[]> {
    return this.http.get<Plantilla[]>(this.plantillasURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getPlantilla(id: string): Observable<any> {
    const getPlantillaURL = urlJoin(this.plantillasURL, id)
    return this.http.get<Plantilla>(getPlantillaURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updatePlantilla(id: string, plantilla: Plantilla): Observable<any> {
    const updatePlantillaURL = urlJoin(this.plantillasURL, id)
    return this.http.put<Plantilla>(updatePlantillaURL, plantilla)
      .pipe(
        tap(() => {
          const updatePlantillaSuccessMessage: string = $localize`:@@updatePlantillaSuccessMessage:Plantilla modificada correctamente`;
          this.notificationsService.showSuccessNotification(updatePlantillaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deletePlantilla(id: string): Observable<any> {
    const deletePlantillaURL = urlJoin(this.plantillasURL, id)
    return this.http.delete<Plantilla>(deletePlantillaURL)
      .pipe(
        tap(() => {
          const deletePlantillaSuccessMessage: string = $localize`:@@deletePlantillaSuccessMessage:Plantilla eliminada correctamente`;
          this.notificationsService.showSuccessNotification(deletePlantillaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newPlantilla(plantilla: Plantilla): Observable<any> {
    const newPlantillaURL = urlJoin(this.plantillasURL)
    return this.http.post<Plantilla>(newPlantillaURL, plantilla)
      .pipe(
        tap(() => {
          const newPlantillaSuccessMessage: string = $localize`:@@newPlantillaSuccessMessage:Nueva plantilla creada correctamente`;
          this.notificationsService.showSuccessNotification(newPlantillaSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
